
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { Runnit } from '@run-diffusion/shared';
import { RunnitsCRUDMixin, TeamUserMixin } from '@/mixins';
import RunnitBoardsDashboard from './RunnitBoardsDashboard/RunnitBoardsDashboard.vue';
import RunnitManageAccessDialog from '@/views/Runnits/RunnitManageAccessDialog/RunnitManageAccessDialog.vue';

export default Vue.extend({
	name: 'RunnitBoardsPage',
	metaInfo: {
		title: 'Boards',
	},
	mixins: [
		RunnitsCRUDMixin,
		TeamUserMixin,
	],
	data () {
		return {
			editRunnitAccessConfig: {
				open: false,
				runnits: [],
				onSuccess: () => {},
			},
		};
	},
	computed: {
		...mapState([
			'runnitState',
			'team',
		]),
	},
	methods: {
		...mapActions([
			'updateRunnitState',
		]),
		onEditRunnit (runnit: Runnit) {
			this.onEditRunnitSettings(runnit);
		},
		onOpenRunnit (runnit: Runnit) {
			this.onOfferingCardClick(runnit.id, null, {}, true, runnit.type);
		},
		onDeleteRunnit (runnit: Runnit) {
			this.updateRunnitState({
				runnitDeleteOpen: true,
				runnit: runnit,
			});
		},
		onEditRunnitAccess ({ runnits, onSuccess }) {
			this.editRunnitAccessConfig = {
				open: true,
				runnits,
				onSuccess: onSuccess || (() => {}),
			};
		},
	},
	components: {
		RunnitBoardsDashboard,
		RunnitManageAccessDialog,
	},
});
